import providers from "@/lib/api";

export default function usePaymentPackage() {
  const findAll = (type?: string[]) => {
    return providers.PaymentPackageProvider.findAll({ type });
  };

  return {
    findAll,
  };
}
